export const OpenLinesMessageComponent = Object.freeze({
	StartDialogMessage: 'StartDialogMessage',
	HiddenMessage: 'HiddenMessage',
	FeedbackFormMessage: 'FeedbackFormMessage',
	ImOpenLinesForm: 'bx-imopenlines-form',
	ImOpenLinesMessage: 'bx-imopenlines-message',
});

export const FormType = Object.freeze({
	none: 'none',
	like: 'like',
	welcome: 'welcome',
	offline: 'offline',
	history: 'history',
});
